import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import React from 'react';

import View from '../View/View';

import { TXTMOB_My_Tickets } from './TournamentTickets.messages.json';
import TournamentTicketsNonPokerContent from './components/TournamentTicketsNonPokerContent/TournamentTicketsNonPokerContent';
import TournamentTicketsPokerContent from './components/TournamentTicketsPokerContent/TournamentTicketsPokerContent';

export const TournamentTicketsBody: React.FC<Partial<ClassNameProp>> = ({ className }) => {
  const webPokerEnabled = useFeature(FeatureFlag.WebPokerEnabled);

  return (
    <div className={className}>
      {webPokerEnabled ? <TournamentTicketsPokerContent /> : <TournamentTicketsNonPokerContent />}
    </div>
  );
};

const TournamentTickets: React.FC = () => (
  <View title={<Translation {...TXTMOB_My_Tickets} />}>
    <TournamentTicketsBody />
  </View>
);

export default TournamentTickets;
